<template>

    <div id="app">
        <Header></Header>
        <Blog></Blog>
        <Footer></Footer>
    </div>


</template>

<script>

    import Header from "./components/Header";
    import Footer from "./components/Footer";
    import BlockC from "./components/BlockC";
    import Services from "./components/Services";
    import Blog from "./components/Blog";

    export default {
        name: 'app',

        data: () => ({}),
        components: {
            Blog,
            Services,
            BlockC,
            Footer,
            Header,


        }
    }
</script>
